<template>
  <div>
    <row v-for="(item,i) in name" :name="item" :data="that[`config${i+1}`].arr" :teamIndex.sync="that[`config${i+1}`].index"
         :key="'industryType'+i"
         v-if="i==showi||(that[`config${i}`]&&that[`config${i}`].index&&that[`config${i+1}`].arr.length>1)"></row>
  </div>
</template>

<script>
  import { apiFlexibleEmployment } from "@/api/apiFlexibleEmployment"
  import sessionStorage from "@/storage/sessionStorage"
	export default {
		name: "industryType",
    components: {
      row: () => import("./row"),
    },
		data() {
			return {
			  name:['行业类别','专业分类','工种'],
        showi:-1,//当前显示项
        that:this,
        config1:{
          arr:[],
          index:''
        },
        config2:{
          arr:[],
          index:''
        },
        config3:{
          arr:[],
          index:''
        }
			}
		},
		watch: {},
		created() {
			this.GetClassification()
		},
		methods: {
      /** @name 获取联动-分类 */
      async GetClassification() {
        if(!this.$store.state.HC_industryType){
          let res = await apiFlexibleEmployment.GetClassification()
          this.createdata(res.data.data,1);
          this.$store.state.HC_industryType=res.data.data;
        }else{
          this.createdata(this.$store.state.HC_industryType,1);
        }
        this.$nextTick(v=>{
          this.computshow();
          this.getquery();
        })
      },
      createdata(data,type){
        if(type>3)return;
			  this[`config${type}`].arr=[
          {
            children: [],
            name: "全部",
            no: null,
            parentNo: null,
          },
          ...data
        ]
        while(type<4){
          this[`config${type}`].index='';
          type++;
        }
      },
      //计算是否显示行业
      computshow(){
        if(this.$parent.config.includes('industryTypeS')){
          this.showi=1;
          let no=process.env.VUE_APP_TEAM_INDUSTRYNO;
          let arr=[];
          this.config1.arr.map(v=>{
            if(v.no==no){
              arr=[{
                children: [],
                name: "全部",
                no: null,
                parentNo: null,
                show: true
              }, ...v.children]
            }
          })
          this.config2.arr=arr
          this.config1.index=1
        }else{
          this.showi=0
        }
      },
			/** @name 搜索单项 */
			send(name) {
			  let arr=[];
			  let index=this.name.indexOf(name)+1;
        if(index<6){
          const config = this[`config${index}`].arr[this[`config${index}`].index]
          let data=config&&config.children;
          if(!data)data=[];
          this.createdata(data,index+1)
        }
			  for(let i=this.showi+1;i<index+1;i++){
			    if(this[`config${i}`].index){
            arr.push(this[`config${i}`].arr[this[`config${i}`].index])
          }else{
			      break;
          }
        }
				//添加搜索项
				this.$parent.$refs.screen.industryType=arr;
			},
			/** @name 清队单项 */
			close(item) {
        item++;
        while(item<4){
          this[`config${item}`].index='';
          item++;
        }
			},
			/** @name 清空所有 */
			closeall() {
        this.config1.index = ''
        this.config2.index = ''
			},
      //读取搜索历史
      getquery(){
        if(!this.$parent.getquery)return;
        //判断是否有筛选历史
        let query = sessionStorage.read('query')
        if(query) {
          query = JSON.parse(query)
          //判断是几级菜单
          let id={};
          if(query[0])id.config1=query[0]
          if(query[1])id.config2=query[1]
          if(query[2])id.config3=query[2]
          for(let i=1;i<4;i++){
            let _i='';
            this[`config${i}`].arr.map((v,j)=>{
              if(v.no===id[`config${i}`])_i=j;
            })
            this[`config${i}`].index=_i;
            if(_i==='')break;
            this.createdata(this[`config${i}`].arr[this[`config${i}`].index].children,i+1)
          }
          this.send(this.name[this.name.length-1])
        }
      },
		},
	}
</script>

<style scoped>

</style>
